import * as React from "react"

import { NavMain } from "@/components/NavBarRework/components/nav-main"
import { NavUser } from "@/components/NavBarRework/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { Logo } from "@/components/misc"
import { useAuth } from "@/App"
import { LogOut } from "@/components/NavBar/UI/Components/LogOut"

// This is sample data.
export function NavSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth()
  if (!user) return null

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <Logo />
      </SidebarHeader>
      
      <SidebarContent>
        <NavMain items={user.nav_bar_items?.navMain || []} />
      </SidebarContent>

      <SidebarFooter>
        <NavUser user={user.nav_bar_items?.user || {name: "", email: "", role: ""}} />
      </SidebarFooter>

      <LogOut />

      <SidebarRail />
    </Sidebar>
  )
}
